import { useEffect, useState } from "react";

import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import useLocalization from "../../hooks/useLocalization";
import useData from "../../hooks/useData";

import Date from "../elements/Date";
import Delete from "../elements/Delete";
import EditorToolbar from "../editors/EditorToolbar";
import Input from "../elements/Input";
import Select from "../elements/Select";

const Visibility = ({ value, label, onChange, onSave }) => {
  const theme = useTheme();

  const { getLabel, getMessage, visibilityFilters, provinces } =
    useLocalization();
  const { getFromServer, sortByFields } = useData();

  const [retailers, setRetailers] = useState([]);
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const retailerList = await getFromServer({ entityName: "Retailer" });
    setRetailers(sortByFields(retailerList, ["name"]));

    const bannerList = await getFromServer({ entityName: "Banner" });
    setBanners(sortByFields(bannerList, ["name"]));
  };

  const handleAdd = () => {
    let newValue = [...(value ? value : []), { name: "", value: null }];

    onChange(newValue);
  };

  const handleChange = (index, field, newValue) => {
    let newVisibility = [];

    for (let x = 0; x < value.length; x++) {
      if (x !== index) {
        newVisibility.push(value[x]);
        continue;
      }

      newVisibility.push({ ...value[x], [field]: newValue });
    }

    onChange(newVisibility);
  };

  const handleDelete = (index) => {
    let newVisibility = [];
    for (let x = 0; x < value.length; x++) {
      if (x !== index) {
        newVisibility.push(value[x]);
      }
    }

    onChange(newVisibility);
  };

  return (
    <Box
      width="100%"
      display="flex"
      flexDirection="column"
      border="1px solid #ccc"
      borderRadius="5px"
    >
      {label ? <Typography align="center">{label}</Typography> : null}
      <EditorToolbar
        onAdd={handleAdd}
        onSave={onSave}
      />
      <Box
        display="flex"
        flexDirection="column"
        gap={1}
        padding="8px"
      >
        {Array.isArray(value) && value.length > 0 ? (
          <Box
            display="flex"
            flexDirection="column"
            paddingTop="5px"
          >
            {value.map((filter, index) => (
              <Box
                display="flex"
                alignItems="center"
                gap={1}
                width="100%"
                marginBottom="10px"
              >
                <Select
                  label={getLabel("filter")}
                  value={filter.name}
                  onChange={(newValue) => handleChange(index, "name", newValue)}
                  items={visibilityFilters}
                />

                {filter.name ? (
                  <Select
                    label={getLabel("value")}
                    value={filter.value}
                    onChange={(newValue) =>
                      handleChange(index, "value", newValue)
                    }
                    items={
                      filter.name === "retailer"
                        ? retailers
                        : filter.name === "banner"
                        ? banners
                        : provinces
                    }
                  />
                ) : null}

                <Delete
                  id={index}
                  onDelete={handleDelete}
                />
              </Box>
            ))}
          </Box>
        ) : (
          <Typography variant="overline">{getMessage("notSet")}</Typography>
        )}
      </Box>
    </Box>
  );
};

export default Visibility;
